(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    /* Delegated from the document so the handlers survive the section re-renders
     that the variant picker triggers. */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches || !form.matches('[data-buy-buttons] form')) return;

    event.preventDefault();

    const error = form.closest('[data-buy-buttons]').querySelector('[data-buy-buttons-error]');
    if (error) error.hidden = true;

    const formData = new FormData(form);
    const id = formData.get('id');
    if (!id) return;

    /* Hand the add over to the cart drawer instead of a full page POST. */
    const button = event.submitter || form.querySelector('[data-add-to-cart]');
    document.dispatchEvent(new CustomEvent('cart:add', { detail: window.cartAddDetail(formData, button) }));
  });

  document.addEventListener('cart:error', (event) => {
    if (!event.detail || !event.detail.message) return;

    document.querySelectorAll('[data-buy-buttons-error]').forEach((error) => {
      error.textContent = event.detail.message;
      error.hidden = false;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    /* Scroll-snap carousel: the browser owns the scrolling, we only keep the
     thumbnails in sync and expose `goToMediaId` for the variant picker. */
  class ProductGallery {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-product-gallery-viewport]');
      this.slides = Array.from(root.querySelectorAll('[data-product-gallery-slide]'));
      this.thumbs = Array.from(root.querySelectorAll('[data-product-gallery-thumb]'));

      if (!this.viewport || this.slides.length === 0) return;

      this.activeIndex = 0;
      this.scrollRaf = null;
      /* Our smooth scroll passes over intermediate slides; recomputing the
         active index mid-flight makes the thumbnails flicker. */
      this.ignoreScrollUntil = 0;

      this.bind();
      this.setActive(0);

      root.productGallery = this;
    }

    bind() {
      const prev = this.root.querySelector('[data-product-gallery-prev]');
      const next = this.root.querySelector('[data-product-gallery-next]');

      if (prev) prev.addEventListener('click', () => this.goToIndex(this.activeIndex - 1));
      if (next) next.addEventListener('click', () => this.goToIndex(this.activeIndex + 1));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goToIndex(Number(thumb.dataset.index)));
      });

      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goToIndex(this.activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goToIndex(this.activeIndex + 1);
        }
      });

      this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });
    }

    onScroll() {
      if (performance.now() <= this.ignoreScrollUntil) return;
      if (this.scrollRaf) return;

      this.scrollRaf = window.requestAnimationFrame(() => {
        this.scrollRaf = null;

        let closest = this.activeIndex;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - this.viewport.offsetLeft - this.viewport.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = index;
          }
        });

        if (closest !== this.activeIndex) this.setActive(closest);
      });
    }

    setActive(index) {
      this.activeIndex = index;
      this.thumbs.forEach((thumb) => {
        thumb.setAttribute('aria-selected', Number(thumb.dataset.index) === index ? 'true' : 'false');
      });
    }

    goToIndex(index) {
      const total = this.slides.length;
      const bounded = ((index % total) + total) % total;
      const slide = this.slides[bounded];
      if (!slide) return;

      this.setActive(bounded);
      this.ignoreScrollUntil = performance.now() + 900;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollTo({
        left: slide.offsetLeft - this.viewport.offsetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    goToMediaId(mediaId) {
      if (!mediaId) return;
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
      if (index >= 0 && index !== this.activeIndex) this.goToIndex(index);
    }
  }

  function initProductGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach((root) => {
      if (!root.productGallery) new ProductGallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGalleries);
  } else {
    initProductGalleries();
  }

  /* The theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', initProductGalleries);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-quantity-input]');
      if (!this.input) return;

      this.querySelector('[data-quantity-decrease]').addEventListener('click', () => this.step(-1));
      this.querySelector('[data-quantity-increase]').addEventListener('click', () => this.step(1));
    }

    step(direction) {
      if (direction > 0) this.input.stepUp();
      else this.input.stepDown();

      /* stepUp/stepDown do not fire events, but other components (and the
         browser's own validation) listen for them. */
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }
  } catch(e) { console.error(e); }
})();

})();
